import apiClient from '@/lib/apiClient';
import type { ApiResponse } from '@/lib/apiClient';
import type { PayType, PayStatus } from './types';

export async function fetchPayTypes(): Promise<PayType[]> {
  const { data } = await apiClient.get<ApiResponse<PayType[]>>('/api/pay/types');
  if (!data.success) throw new Error('Ошибка загрузки типов оплат');
  return data.response ?? [];
}

export async function fetchPayStatuses(): Promise<PayStatus[]> {
  const { data } = await apiClient.get<ApiResponse<PayStatus[]>>('/api/pay/statuses');
  if (!data.success) throw new Error('Ошибка загрузки статусов оплат');
  return data.response ?? [];
}
